module.exports = __webpack_public_path__ + "379cce098ce544b7685efe5fb8e35208.pdf";